'use strict';
import './mobile-offer-details.scss';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import DevicesListModal from 'app/shared/components/pop-up/devices-list-modal';
import { TabContent, TabPane, Nav, NavItem, NavLink, Button, Row, Card, CardText, Col, Container } from 'reactstrap';
import classnames from 'classnames';
import { CoversDisplayMode } from 'app/modules/corporate/service/store/corporate.state';
import FormModal from '../../../../../../shared/components/pop-up/form-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Translate } from 'react-jhipster';
import { hidePageMarketing, openDocument } from 'app/modules/corporate/service/corporate.service';
import { gtmEvent } from 'app/modules/gtm/service/gtm.service';
import DOMPurify from "dompurify";
import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { CmsPageContentType } from 'app/modules/cms/tools/types';

const MobileOfferDetails = () => {

  const dispatch = useDispatch();

  const { DIPA } = useSelector((state: IRootState) => state.offers.docUrl) || {}
  const { code, extras, badgeURL, contribution, title, extraTitle, coverTitle, covers, showAmount } = useSelector((state: IRootState) => state.offers.selectedOffer)

  const [activeTab, setActiveTab] = useState('1');
  const [modal, setModal] = useState(false);
  const [amountModal, setAmountModal] = useState(false);
  const [coverDetails, setCoverDetails] = useState(null);
  const cmsContent: any = useSelector(getContent(CmsPageContentType.CUSTOMER_OFFERS_STEP_CONTENT));


  const handleOpenDocument = (url, type) => {
    dispatch(openDocument(url, type));
  }

  const toggleDevicesListModal = (coverDetailsList) => {
    dispatch(gtmEvent('Informations assurance', code, '0'))
    setCoverDetails(coverDetailsList)
    setModal(!modal)
  };

  const toggleAmountModal = () => {
    setAmountModal(!amountModal)
  };

  const comeBack = () => {
    dispatch(hidePageMarketing());
  }

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }

  if (code) {
    return (
      <>
        <div className="insuredOfferWrapper">
          <div className="navigationMobileBtnFlexBox">
            <Button className="stepButton" onClick={() => comeBack()} >
              {/* <svg onClick={stepActionsStore.showPreviousButton ? handleGoToPreviousStepEvent : undefined} xmlns="http://www.w3.org/2000/svg" width="39" height="68.209" viewBox="0 0 39 68.209"><defs></defs><path className="a" d="M40.3,38.49,66.1,12.678a4.854,4.854,0,0,1,6.884,0,4.915,4.915,0,0,1,0,6.9L43.757,48.826a4.865,4.865,0,0,1-6.722.142L7.609,19.6a4.875,4.875,0,0,1,6.884-6.9Z" transform="translate(50.246 -6.188) rotate(90)" /></svg> */}
              <span id="previousStepButton">
                <FontAwesomeIcon icon="chevron-left" />
              </span>
            </Button>
          </div>
          <div className="cardBodyOffer d-flex">
            {badgeURL && <div>
              <img style={{ width: "70px" }} alt="cover" src={badgeURL} />
            </div>}
            {code && <div className="p-2 flex-grow-1 d-flex flex-column mobileOfferInfos">
              <div className="selectedOfferTitleCls" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }} />
              {showAmount &&
                <p className="selectedOfferPriceCls">
                  {contribution}
                  <FontAwesomeIcon icon="info-circle" style={{ marginLeft: "5px" }} onClick={() => toggleAmountModal()} />
                </p>}
            </div>}
          </div>
          <Nav tabs>
            <NavItem className={classnames({ 'activeNavItem': activeTab === '1' })}>
              <NavLink
                className={classnames({ active: activeTab === '1' }, { 'addOpacity': activeTab === '2' })}
                onClick={() => { toggle('1'); }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(coverTitle) }}
              />
            </NavItem >
            <NavItem className={classnames({ 'activeNavItem': activeTab === '2' })}>
              <NavLink
                className={classnames({ active: activeTab === '2' }, { 'addOpacity': activeTab === '1' })}
                onClick={() => { toggle('2'); }}
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(extraTitle) }}
              />
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">
              <Container>
                <Row>
                  {covers.map((offerInfo, index) => {
                    if (offerInfo.agent === CoversDisplayMode.MOBILE) {
                      return (
                        <Col xs={6} key={index} style={{ marginTop: "20px" }}
                          onClick={() => toggleDevicesListModal({ title: offerInfo.title, list: offerInfo.text })} >
                          <Card body className="coversCard">
                            <CardText>
                              <img alt="cover" className="coversIcon" src={offerInfo.iconURL} />
                              <FontAwesomeIcon className="coversInfo" icon="info-circle" />
                              <span className="coversText" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(offerInfo.title) }} />
                            </CardText>
                          </Card>
                        </Col>
                      )
                    }
                  })}

                </Row>

                {DIPA !== "" &&
                  <Row className="mobileLinksBtnWrapper" >
                    <Col xs={12}>
                      <a className="mobileLinksBtn" onClick={() => handleOpenDocument(DIPA, "DIPA")}>
                        <FontAwesomeIcon icon="eye" />
                        <span>{cmsContent && cmsContent?.documentLink}</span>
                      </a>
                    </Col>
                  </Row>
                }
              </Container>
            </TabPane>
            <TabPane tabId="2">
              <Container>
                <Row>
                  {extras.map((offerInfo, index) => {
                    return (
                      <Col xs={6} key={index} style={{ marginTop: "20px" }}>
                        <Card body className="coversCard">
                          <CardText>
                            <img alt="cover" className="coversIcon" src={offerInfo.iconURL} />
                            <span className="coversText" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(offerInfo.title) }} />
                          </CardText>
                        </Card>
                      </Col>
                    )
                  })}
                </Row>
              </Container>
            </TabPane>
          </TabContent>
        </div>
        {coverDetails != null && <DevicesListModal modal={modal} setModal={setModal} buttonLabel={"change"} className="devicesListModalCls" coverDetails={coverDetails} />}
        <FormModal modal={amountModal} setModal={setAmountModal} className="mobileModalCls">
          <div className="amountModalDescription">
            {/* {message} */}
            {cmsContent?.amount}
            {contribution}
            {cmsContent?.sampleInfoBox}
          </div>
          <Button className="devicesListModalBtn" onClick={toggleAmountModal}>
            Compris
            {'  '}
            <FontAwesomeIcon icon="arrow-right" />
          </Button>
        </FormModal>
      </>
    );
  } else {
    return <button className="return" onClick={() => comeBack()}>
      <img alt="cover" style={{ width: "10px" }} src={'/content/images/arrow_back.svg'} />
    </button>;
  }
}

export default MobileOfferDetails;
